































import Vue from "vue";
import ScrollReveal from "scrollreveal";
import MainVideoSection from "@/components/home-view/main-video-section/MainVideoSection.vue";
import MainTextSection from "@/components/home-view/main-text-section/MainTextSection.vue";
import MainImageSection from "@/components/home-view/main-image-section/MainImageSection.vue";
import MainLeadership from "@/components/home-view/main-leadership/MainLeadership.vue";
import MainPipeline from "@/components/home-view/main-pipeline/MainPipeline.vue";
import ContactUs from "@/components/shared/contact-us/ContactUs.vue";
import { scrollConfig } from "@/resources/animations/configs.ts";

export default Vue.extend({
  name: "Home",
  components: {
    MainVideoSection,
    MainTextSection,
    MainImageSection,
    MainLeadership,
    MainPipeline,
    ContactUs
  },
  data() {
    return {
      showAnimation: false,
      sections: {
        technology: "technology",
        leadership: "leadership",
        pipeline: "pipeline",
        contactUs: "contact-us"
      },
      aboutContent: [
        "Drug Farm builds unique platforms to develop innovative treatments for infection and immunological diseases. Drug Farm's IDInVivo⁺ platform allows utlilizing genetic screens to directly identify novel drug targets in living animals with intact immune systems. Drug Farm's MedChem5 platform harnesses the power of deep learning technologies to accelerate first-in-class drugs development. ",
        "Combining IDInVivo⁺ and MedChem5 platforms, Drug Farm has identified novel immunity targets and developed first-in-class drug candidates reaching clinical stage. "
      ],
      technologyContent: [
        "Drug Farm's IDInVivo⁺ technology uses piggyBac transposon mutagenesis to generate a library of genetic mutations in mice. Mice with mutated individual genes are then analyzed to identify drug targets connected to host immunity. Potential drug targets are then validated in Drug Farm's laboratories using in vivo genetics and in vitro biochemistry and cell biology. "
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.showAnimation = true;
    this.setRevealAnimation();
  },
  methods: {
    setRevealAnimation() {
      Object.entries(this.sections).forEach((section: string[]) => {
        ScrollReveal().reveal(`.${section[1]}`, scrollConfig);
      });
    }
  }
});
